export const factors = [
  {
    'id': 'risk',
    'label': 'Risk Score',
    'description': 'Vulnerability score based on proximity of population to hazards',
    'paint': {
      'fill-color': 'hsl(16, 94%, 42%)',
      'fill-opacity': [ 'interpolate', ['linear'], ['get', 'risk'], 0, 0, 1, 1 ],
      'fill-outline-color': 'white'
    }
  },
  {
    'id': 'landslide',
    'label': 'Landslide',
    'description': 'Based on frequency of landslides due to earthquake or precipitation. Source: UNEP GRID.',
    'paint': {
      'fill-color': 'hsl(45, 94%, 50%)',
      'fill-opacity': [ 'interpolate', ['linear'], ['get', 'landslide'], 0, 0, 0.2, 1 ],
      'fill-outline-color': 'white'
    }
  },
  {
    'id': 'quake',
    'label': 'Earthquake',
    'description': 'Based on earthquake occurence for the past 100 years. Source: USGS',
    'paint': {
      'fill-color': 'hsl(27, 100%, 61%)',
      'fill-opacity': [ 'interpolate', ['linear'], ['get', 'quake'], 0, 0, 0.4, 1 ],
      'fill-outline-color': 'white'
    }
  },
  {
    'id': 'flood',
    'label': 'Flood',
    'description': 'Based on exposure to flooding. Source: UNEP GRID.',
    'paint': {
      'fill-color': 'hsl(207, 84%, 53%)',
      'fill-opacity': [ 'interpolate', ['linear'], ['get', 'flood'], 0, 0, 0.001, 1 ],
      'fill-outline-color': 'white'
    }
  },
  {
    'id': 'tsunami',
    'label': 'Tsunami',
    'description': 'Based on tsunami frequency over the past 500 years. UNEP GRID.',
    'paint': {
      'fill-color': 'hsl(231, 47%, 47%)',
      'fill-opacity': [ 'interpolate', ['linear'], ['get', 'tsunami'], 0, 0, 0.3, 1 ],
      'fill-outline-color': 'white'
    }
  },
  {
    'id': 'cyclones',
    'label': 'Typhoon',
    'description': 'Based on cyclone tracks for the past 50 years. NOAA.',
    'paint': {
      'fill-color': 'hsl(187, 86%, 44%)',
      'fill-opacity': [ 'interpolate', ['linear'], ['get', 'cyclones'], 0, 0, 0.4, 1 ],
      'fill-outline-color': 'white'
    }
  },
  {
    'id': 'volc',
    'label': 'Volcano',
    'description': 'Based on proximity of a barangay to a volcano. Source: PHIVOLCS.',
    'paint': {
      'fill-color': 'hsl(4, 97%, 45%)',
      'fill-opacity': [ 'interpolate', ['linear'], ['get', 'volc'], 0, 0, 0.4, 1 ],
      'fill-outline-color': 'white'
    }
  }
]
